(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxt-daynight"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.documentElement;
    var KEY='nxtTheme';
    var btn=document.querySelector('.nxt-dn');
    if(!btn) return;
    btn.addEventListener('click',function(){
      var isDay=root.getAttribute('data-nxt-theme')==='day';
      if(isDay){root.removeAttribute('data-nxt-theme');try{localStorage.setItem(KEY,'night');}catch(e){}}
      else{root.setAttribute('data-nxt-theme','day');try{localStorage.setItem(KEY,'day');}catch(e){}}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxt-header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.documentElement;
    function setVars(){
      var a=document.querySelector('.announcement-bar-section');
      var h=document.querySelector('.nxt-hd');
      if(a){root.style.setProperty('--nxt-ann-h',a.offsetHeight+'px');}
      if(h){root.style.setProperty('--nxt-hd-h',h.offsetHeight+'px');}
    }
    setVars();
    window.addEventListener('resize',setVars);
    window.addEventListener('load',setVars);
    var btn=document.querySelector('.nxt-totop');
    if(btn){
      var onScroll=function(){
        if((window.pageYOffset||document.documentElement.scrollTop)>400){btn.classList.add('is-visible');}
        else{btn.classList.remove('is-visible');}
      };
      window.addEventListener('scroll',onScroll,{passive:true});
      onScroll();
    }
    var sBtn=document.querySelector('.nxt-hd__searchbtn');
    var sPanel=document.querySelector('.nxt-hd__search');
    if(sBtn&&sPanel){
      var sInput=sPanel.querySelector('.nxt-hd__search-input');
      var sResults=sPanel.querySelector('.nxt-hd__search-results');
      var sClose=sPanel.querySelector('.nxt-hd__search-close');
      var rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      var t;
      function openS(){sPanel.classList.add('open');sBtn.setAttribute('aria-expanded','true');setTimeout(function(){sInput.focus();},30);}
      function closeS(){sPanel.classList.remove('open');sBtn.setAttribute('aria-expanded','false');}
      sBtn.addEventListener('click',function(e){e.preventDefault();sPanel.classList.contains('open')?closeS():openS();});
      sClose.addEventListener('click',closeS);
      document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeS();}});
      document.addEventListener('click',function(e){if(sPanel.classList.contains('open')&&!sPanel.contains(e.target)&&!sBtn.contains(e.target)){closeS();}});
      function esc(s){return (s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
      function render(q,data){
        var prods=(data&&data.resources&&data.resources.results&&data.resources.results.products)||[];
        if(!q){sResults.innerHTML='';return;}
        if(prods.length===0){sResults.innerHTML='<p class="nxt-hd__search-empty">Keine Treffer für “'+esc(q)+'”.</p>';return;}
        var html='';
        prods.forEach(function(p){
          var img=p.image?('<img src="'+p.image+'" alt="" loading="lazy">'):'<img alt="">';
          var price=p.price?('<span class="nxt-hd__sr-p">'+esc(p.price)+'</span>'):'';
          html+='<a class="nxt-hd__sr" href="'+p.url+'">'+img+'<span class="nxt-hd__sr-info"><span class="nxt-hd__sr-t">'+esc(p.title)+'</span>'+price+'</span></a>';
        });
        html+='<a class="nxt-hd__search-all" href="'+rootUrl+'search?q='+encodeURIComponent(q)+'">Alle Ergebnisse anzeigen &rarr;</a>';
        sResults.innerHTML=html;
      }
      function doSearch(){
        var q=sInput.value.trim();
        if(q.length<2){sResults.innerHTML='';return;}
        var url=rootUrl+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6';
        fetch(url).then(function(r){return r.json();}).then(function(d){render(q,d);}).catch(function(){});
      }
      sInput.addEventListener('input',function(){clearTimeout(t);t=setTimeout(doSearch,220);});
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
